import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useToast } from '../../hooks/useToast';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
}

export function Shell({ children }: Props) {
  const toasts = useToast();
  return (
    <div className="h-full flex bg-page">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto px-5 py-4">
          {children}
        </main>
      </div>
      {toasts.length > 0 && (
        <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
          {toasts.map(t => (
            <div key={t.id} className={clsx(
              'border rounded-md px-3 py-2 shadow-sm text-sm',
              t.kind === 'success' && 'bg-green-50 border-green-200 text-success',
              t.kind === 'error'   && 'bg-red-50 border-red-200 text-danger',
              t.kind === 'info'    && 'bg-blue-50 border-blue-200 text-info',
            )}>
              {t.message}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
